import { z } from 'zod';

/**
 * The single error shape every TABITA endpoint returns.
 *
 * `code` is stable and machine-readable so clients can branch on it and so the
 * web app can look up a translated message. `message` is developer-facing
 * English; it is never shown to an end user verbatim.
 */
export const errorEnvelopeSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.string(), z.unknown()).default({}),
    correlationId: z.string(),
  }),
});

export type ErrorEnvelope = z.infer<typeof errorEnvelopeSchema>;

export function buildErrorEnvelope(input: {
  code: string;
  message: string;
  details?: Record<string, unknown>;
  correlationId: string;
}): ErrorEnvelope {
  return {
    error: {
      code: input.code,
      message: input.message,
      details: input.details ?? {},
      correlationId: input.correlationId,
    },
  };
}

/**
 * Field-level validation failures.
 *
 * `path` uses dotted notation (`contacts.0.value`) so the web form can attach
 * each message to the right input.
 */
export const fieldErrorSchema = z.object({
  path: z.string(),
  code: z.string(),
  message: z.string(),
});

export type FieldError = z.infer<typeof fieldErrorSchema>;
